import { getAppOrigin } from '../utils/appOrigin';

export const PASSWORD_RESET_PATH = '/reset-password';

function normalizeText(value) {
  return typeof value === 'string' ? value.trim() : '';
}

// A configured redirect is honored only when it resolves to the application
// origin the browser is already running on. A stale or cross-environment value
// must never send a staging or preview user into another environment, and a
// missing value must never fall back to production.
function resolveSameOriginConfiguredUrl(appOrigin) {
  const configuredUrl = normalizeText(process.env.REACT_APP_PASSWORD_RESET_REDIRECT_URL);
  if (!configuredUrl || !appOrigin) return '';

  let parsed;
  try {
    parsed = new URL(configuredUrl);
  } catch {
    return '';
  }

  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return '';
  if (parsed.username || parsed.password) return '';
  if (parsed.origin !== appOrigin) return '';

  return parsed.toString();
}

export function getPasswordRecoveryRedirectUrl(currentLocation = typeof window !== 'undefined' ? window.location : null) {
  const appOrigin = getAppOrigin(currentLocation);
  const configuredUrl = resolveSameOriginConfiguredUrl(appOrigin);
  if (configuredUrl) return configuredUrl;

  // With no resolvable application origin there is no safe URL to supply, so
  // Supabase Auth applies its own configured Site URL instead.
  return appOrigin ? `${appOrigin}${PASSWORD_RESET_PATH}` : '';
}
